import { useParams, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import CryptoAgent from "./CryptoAgent";

const AssetView = () => {
  const { symbol } = useParams<{ symbol: string }>();
  const [shouldOpenDrawer, setShouldOpenDrawer] = useState(false);

  useEffect(() => {
    if (symbol) {
      // Small delay to ensure the main page is loaded before opening drawer
      const timer = setTimeout(() => {
        setShouldOpenDrawer(true);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [symbol]);

  if (!symbol) {
    return <Navigate to="/" replace />;
  }

  return <CryptoAgent initialAssetSymbol={shouldOpenDrawer ? symbol : undefined} />;
};

export default AssetView;